import TabPage from "./../factories/tab-page";
import "./../bindings/bao-tabs";
import "./../services/bao-menu";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
class ConfigurationItemTabBasedata extends BaseViewModel {
    /** Name Property
     */
    ConfigurationItemTab = ko.observable<string>();
    Description = ko.observable<string>();
    TabPageConfigurationItemTypeCategoryTab = new TabPage();
    TabPageUniversalFieldTab = new TabPage();
    public constructor(tabPage: TabPage) {
        super(tabPage);
    }
    public CompleteCheck(): JQueryPromise<boolean> | boolean {
        var completed: boolean;
        completed = true;
        if (this.ConfigurationItemTab() === "" || this.ConfigurationItemTab() === null) {
            completed = false;
        }
        if (!completed) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
    public InitUrl(): string {
        return "ConfigurationItemTabBasedata/Init";
    }
    public init(): JQueryPromise<void> {
        return super.init()
            .then(() => {
            return this.InitTabController();
        })
            .then(() => {
            this.InitTabPage();
        });
    }
    private InitTabPage() {
        this.TabPageConfigurationItemTypeCategoryTab.Url("ConfigurationItemTabConfigurationItemTypeCategory");
        this.TabPageConfigurationItemTypeCategoryTab.IsClosable(false);
        this.TabPageConfigurationItemTypeCategoryTab.AutoSelect = true;
        this.TabController.AddTab(this.TabPageConfigurationItemTypeCategoryTab);
        this.TabPageUniversalFieldTab.Url("ConfigurationItemTabBaseDataUniversalField");
        this.TabPageUniversalFieldTab.IsClosable(false);
        this.TabPageUniversalFieldTab.AutoSelect = false;
        this.TabController.AddTab(this.TabPageUniversalFieldTab);
    }
}
export default ConfigurationItemTabBasedata;